/**
 * Real-time multiplayer asteroids game with TypeScript/Bun server and HTML5 Canvas client
 * UI domain - Splash text with rotating sci-fi references from 70s-90s
 * splash-text.client.ts - Random splash text display on login screen
 */

const SPLASH_TEXTS = [
  "May the Force be with you",
  "I find your lack of faith disturbing",
  "These aren't the droids you're looking for",
  "I have a bad feeling about this",
  "Do or do not. There is no try",
  "Never tell me the odds",
  "It's a trap!",
  "In space no one can hear you scream",
  "Game over, man! Game over!",
  "Get away from her you...",
  "I say we take off and nuke the site",
  "I've seen things you people wouldn't believe",
  "All those moments will be lost in time",
  "Like tears in rain",
  "More human than human is our motto",
  "I'll be back",
  "Come with me if you want to live",
  "Hasta la vista, baby",
  "The future is not set",
  "There is no spoon",
  "Welcome to the desert of the real",
  "Free your mind",
  "What is real?",
  "Follow the white rabbit",
  "Live long and prosper",
  "Resistance is futile",
  "Make it so",
  "Beam me up, Scotty",
  "Space, the final frontier",
  "I'm a doctor, not a...",
  "Highly illogical",
  "I'm sorry, Dave. I'm afraid I can't do that",
  "My mind is going. I can feel it",
  "Open the pod bay doors, HAL",
  "This means something",
  "E.T. phone home",
  "I'll be right here",
  "Where we're going we don't need roads",
  "Great Scott!",
  "This is heavy",
  "Your kids are gonna love it",
  "Multipass",
  "Leeloo Dallas multipass",
  "Big bada boom",
  "Fear is the mind-killer",
  "The spice must flow",
  "He who controls the spice controls the universe",
  "Consider that a divorce",
  "Get your ass to Mars",
  "See you at the party, Richter!",
  "Dead or alive, you're coming with me",
  "I'd buy that for a dollar!",
  "Your move, creep",
  "Get to the choppa!",
  "You are one ugly...",
  "If it bleeds, we can kill it",
  "I know you gentlemen have been through a lot",
  "Yeah, f*** you too!",
  "I fight for the users",
  "End of line",
  "Greetings, programs!",
  "Shall we play a game?",
  "The only winning move is not to play",
  "How about a nice game of chess?",
  "I have come here to chew bubblegum...",
  "Put on the glasses",
  "We all see what we want to see",
  "Welcome to Earth!",
  "Today we celebrate our Independence Day!",
  "A person is smart. People are dumb",
  "Here come the Men in Black",
  "Would you like to know more?",
  "I'm doing my part!",
  "Service guarantees citizenship",
  "Small moves, Ellie. Small moves",
  "Soylent Green is people!",
  "Take your stinking paws off me!",
  "I am as mad as hell!",
  "Klaatu barada nikto",
  "Logan's Run at 30",
  "By Grabthar's hammer!",
  "Never give up. Never surrender",
  "Help me, Obi-Wan Kenobi",
  "The Force will be with you",
  "You were the chosen one!",
  "Only a Sith deals in absolutes",
  "Strike me down and I'll be stronger",
  "I've got a bad feeling",
  "This is where the fun begins",
  "Engage!",
  "Tea. Earl Grey. Hot.",
  "There are four lights!",
  "Today is a good day to die",
  "Impossible is a word that humans use",
  "The line must be drawn here!",
  "I want to believe",
  "The truth is out there",
  "Trust no one",
  "Deny everything",
  "Bigger on the inside",
  "Allons-y!",
  "Fantastic!",
  "Don't blink",
  "Wibbly wobbly timey wimey",
  "So say we all",
  "Frak!",
  "All of this has happened before",
  "Damn you all to hell!",
  "It's a madhouse!",
  "Get your stinking paws off me",
  "Be afraid. Be very afraid",
  "I'm saying I'm an insect",
  "We're all in it together",
  "Here I am!",
  "We did it!",
  "I'm in insurance",
  "Call me Snake",
  "I heard you were dead",
  "I am the Night Rider!",
  "What a lovely day!",
  "Witness me!",
  "Enhance your calm",
  "What seems to be your boggle?",
  "Murder death kill",
  "Greetings, Starfighter!",
  "Death Blossom deployed",
  "Obey",
  "Consume",
  "Where we're going, we won't need eyes",
  "Liberate tuteme ex inferis",
  "I'll be back... again",
  "Here is Subzero. Now, plain zero",
  "I never saved anything for the swim back",
  "There is no gene for the human spirit",
  "Shut it down!",
  "You have finally become yourself",
  "Are you a user or a seller?",
  "I want room service!",
  "I need to get online",
  "Tetsuo!",
  "Kaneda!",
  "The net is vast and infinite",
  "All things change in a dynamic environment",
  "I am God here!",
  "Cyber Christ",
  "We've been here before",
  "This room is green",
  "Death to the demoness!",
  "Are we still in the game?",
  "I'm gonna suck your brain dry!",
  "Scan me",
  "Your clothes. Give them to me",
  "No fate but what we make",
  "I need your clothes, your boots",
  "Nuke it from orbit. Only way to be sure",
  "We're on an express elevator to hell",
  "Stop your grinnin' and drop your linen",
  "He's dead, Jim",
  "Fascinating",
  "Logic is the beginning of wisdom",
  "Khaaaan!",
  "I have been and always shall be",
  "You have to look with better eyes",
  "Keep a level head",
  "Two weeks",
  "Open your mind",
  "First rule of government spending",
  "They should have sent a poet",
  "The only good bug is a dead bug",
  "Come on, you apes!",
  "1.21 gigawatts!",
  "Make like a tree and get out",
  "Nobody calls me chicken",
  "I could have been at a barbecue!",
  "Upload the virus",
  "You will have no memory of this",
  "We are not hosting an intergalactic kegger",
  "Game over, man!",
  "Exterminate!",
  "We have such sights to show you",
  "I have come here to kick ass",
  "Maximum effort",
];

export function getRandomSplashText(): string {
  return (
    SPLASH_TEXTS[Math.floor(Math.random() * SPLASH_TEXTS.length)] ??
    "Survive the Void"
  );
}

export function initializeSplashText(): void {
  const splashElement = document.getElementById("splashText");

  if (splashElement) {
    splashElement.textContent = getRandomSplashText();
  }
}
